var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('collapse-transition',[(_vm.$_validation_hasValidationError(_vm.error))?_c('div',{staticClass:"input-group__error"},[_vm._v("\n      "+_vm._s(_vm.$_validation_errorMessages(_vm.error)[0])+"\n    ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }